import React from 'react';
// import { ALCChart, RAChart, OWChart, TIChart, SISChart } from './index';
import { ALCChart, OWChart, TIChart } from './index';

const ChartSelector = ({
    deviceType,
    measurements,
    deviceName,
    slopeData,
    deviceId,
    ...props
}) => {
    const chartComponents = {
        ALC: ALCChart,
        // RA: RAChart,
        OW: OWChart,
        TI: TIChart,
        // SIS: SISChart,
    };

    const ChartComponent = chartComponents[deviceType];

    if (!ChartComponent) {
        return (
            <div className="chart-placeholder">
                <p>此設備類型暫不支援圖表顯示</p>
            </div>
        );
    }

    return (
        <ChartComponent
            measurements={measurements}
            deviceName={deviceName}
            slopeData={slopeData}
            deviceId={deviceId}
            {...props}
        />
    );
};

export default ChartSelector;
